import React, { useState } from 'react';
import { Table } from '@ui';
import { columnsInner } from '../../constants';

const PayoutExpandedTable = ({ record }) => {
    const [page, setPage] = useState(1);
    const dataSource = record.items.reduce((acc, item) => {
        acc = [...acc, item];

        if (item.offsets) {
            item.offsets.forEach((element) => {
                acc = [
                    ...acc,
                    {
                        showDetails: true,
                        sequenceNumber: element.invoice?.sequenceNumber,
                        invoiceId: element.invoice?.id,
                        amount: element.amount
                    }
                ];
            });

            return acc;
        }
        return acc;
    }, []);

    return (
        <Table
            rowKey={(r) => r.id}
            borderColor='transparent'
            columns={columnsInner}
            onChange={(pagination) => {
                setPage(pagination?.current);
            }}
            dataSource={dataSource}
            pagination={{
                totalPages: Math.ceil(dataSource?.length / 10),
                pageSize: 10,
                current: page,
                hideOnSinglePage: true,
                showSizeChanger: false,
                showQuickJumper: false,
                position: ['bottomCenter']
            }}
        />
    );
};

export default PayoutExpandedTable;
